export type InvoiceStatus =
  | "draft"
  | "approved"
  | "issued"
  | "sent"
  | "partially_paid"
  | "paid"
  | "refunded"
  | string;

export type StatusBadge = {
  variant: "default" | "secondary" | "outline";
  className: string;
};

export function statusBadge(status: InvoiceStatus): StatusBadge {
  switch (status) {
    case "draft":
      return { variant: "secondary", className: "" };
    case "approved":
    case "issued":
      return { variant: "outline", className: "" };
    case "sent":
      return {
        variant: "default",
        className: "bg-amber-500 hover:bg-amber-500 text-white border-transparent",
      };
    case "partially_paid":
      return {
        variant: "default",
        className: "bg-blue-500 hover:bg-blue-500 text-white border-transparent",
      };
    case "paid":
      return {
        variant: "default",
        className: "bg-green-600 hover:bg-green-600 text-white border-transparent",
      };
    case "refunded":
      return {
        variant: "default",
        className: "bg-slate-500 hover:bg-slate-500 text-white border-transparent",
      };
    default:
      return { variant: "secondary", className: "" };
  }
}

export function statusLabel(status: InvoiceStatus): string {
  if (status === "partially_paid") return "Partially Paid";
  return status.charAt(0).toUpperCase() + status.slice(1);
}

export function netOwedLabel(
  amount: string | number | null | undefined,
  paidAmount?: string | number | null,
  status?: string,
): { text: string; className: string } {
  const num = Number(amount || 0);
  const paid = Number(paidAmount || 0);
  const absAmount = Math.abs(num);
  const outstanding = absAmount - paid;

  if (status === "refunded") {
    return { text: `$${absAmount.toFixed(2)} refunded`, className: "text-slate-500 dark:text-slate-400" };
  }
  if (status === "paid" || (absAmount > 0 && outstanding <= 0.005)) {
    return { text: `$${absAmount.toFixed(2)} paid in full`, className: "text-green-600 dark:text-green-400" };
  }
  if (paid > 0 && outstanding > 0) {
    return { text: `$${outstanding.toFixed(2)} outstanding`, className: "text-amber-600 dark:text-amber-400" };
  }
  if (num >= 0) {
    return { text: `$${num.toFixed(2)} owed by property manager`, className: "text-red-600 dark:text-red-400" };
  }
  return { text: `$${Math.abs(num).toFixed(2)} owed to property manager`, className: "text-green-600 dark:text-green-400" };
}
